import { VAvatar } from 'vuetify/lib/components/VAvatar';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VAvatar,{class:['app-avatar', `color-${_vm.color}`, `bg-${_vm.background}`],attrs:{"size":_vm.size}},[(_vm.imageURL)?_c('img',{staticClass:"image",attrs:{"src":_vm.URL,"alt":"Avatar"}}):_c('span',{style:(`font-size: ${_vm.size / 1.5}px`)},[_vm._v(" "+_vm._s(_vm.text ? _vm.text.replace(/"/, '')[0].toUpperCase() : 'ME'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }